import { useParams } from "react-router-dom";
import { TicketData, TicketMessageData } from "@/entry/server/app";
import React, { useContext, useEffect, useRef, useState } from "react";
import { appRepo } from "@/repo/app-repo";
import MainBG from "@public/img/main-bg.svg";
import TextField from "@/component/widgets/text-field";
import { AppContextType, WonmovContext } from "@/context/app-context";
import LoadingGif from "@public/img/loading.gif";
import { useTicketsRedirect } from "../use-tickets-redirect";

export default function Page() {
    var ticketsEnabled = useTicketsRedirect();
    const routeParams = useParams<{ id: string }>();
    const id = routeParams.id || "";

    const { setNotification } = useContext<AppContextType>(WonmovContext);

    const [ticket, setTicket] = useState<TicketData | null>(null);
    const [messages, setMessages] = useState<TicketMessageData[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [sendingMessage, setSendingMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const messagesContainerRef = useRef<HTMLDivElement>(null);

    useEffect(function () {
        if (!ticketsEnabled) {
            return;
        }
        setLoading(true);
        appRepo.getTicket(Number(id)).then((res) => {
            setTicket(res.data?.ticket ?? null);
            setMessages(res.data?.messages ?? []);
            setLoading(false);

            setTimeout(function () {
                if (messagesContainerRef.current) {
                    messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
                }
            }, 100);
        });
    }, [id, ticketsEnabled]);

    const sendMessage = async () => {
        if (sendingMessage || loading) return;
        if (!message.trim()) return;
        setSendingMessage(true);
        const res = await appRepo.replyToTicket(Number(id), message.trim());
        setSendingMessage(false);
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            return;
        }
        setTicket(res.data ?? null);
        setMessages([{ id: messages.length + 1, is_admin: false, content: message.trim(), created_at: new Date().toISOString() }, ...messages]);
        setMessage("");
        messagesContainerRef.current?.scrollTo({ top: messagesContainerRef.current?.scrollHeight, behavior: "smooth" });
    }

    if (!ticketsEnabled) {
        return null;
    }

    return (
        <div className="w-full min-h-[600px] rounded-3xl bg-bg2 p-4 flex flex-col gap-4 relative">
            <img src={MainBG} alt="Main BG" className="absolute top-0 left-0 w-full h-full object-cover" />
            <div className="w-full flex items-center justify-between z-10">
                <div className="flex items-center gap-1">
                    <p className="text-xl font-extrabold">عنوان: </p>
                    <p className="text-lg line-clamp-1">{ticket?.title}</p>
                </div>

                {ticket && (
                    <>
                        <p className="text-sm text-input mr-auto ml-4 ltr">{ticket.updated_at}</p>
                        <span className={`text-sm text-zinc-100 rounded-full py-0.5 px-2.5 w-fit ${ticket?.status === "answered" ? "bg-sky-600" : ticket?.status === "closed" ? "bg-emerald-600" : "bg-red-600"}`} style={{ textWrap: "nowrap" }}>
                            {ticket.status === "answered" ? "پاسخ داده شده" : ticket.status === "closed" ? "بسته شده" : "درحال بررسی"}
                        </span>
                    </>
                )}
            </div>

            {!loading && (
                <div className="z-10 overflow-y-auto h-[500px] max-h-[500px] flex-1 custom-scrollbar" ref={messagesContainerRef}>
                    <div className="w-full flex flex-col justify-end gap-4">
                        {messages.slice().reverse().map((message) => (
                            <div key={message.id} className={`w-fit max-w-full lg:max-w-1/2 flex items-center gap-2 rounded-2xl py-2.5 px-4 text-zinc-900 ${message.is_admin ? "self-end bg-lime-50 rounded-bl-none" : "self-start bg-lime-200 rounded-br-none"}`}>
                                <p className="text-sm">{message.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {loading && (
                <div className="flex-1 flex flex-col gap-2 items-center justify-center z-10">
                    <img src={LoadingGif} alt="Loading" />
                    <p className="text-sm text-zinc-400">در حال دریافت پیام ها...</p>
                </div>
            )}

            {ticket && ticket.status !== "closed" && (
                <div className="w-full flex items-center gap-5 z-10">
                    <TextField
                        placeholder="پیام خود را اینجا وارد کنید"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                sendMessage();
                            }
                        }}
                    />

                    <button className="w-fit whitespace-nowrap py-3 cursor-pointer rounded-xl bg-lime-400 px-4 text-sm font-semibold text-zinc-900 transition hover:bg-lime-300" onClick={sendMessage}>
                        {sendingMessage ? <div className="loader"></div> : "ارسال پیام"}
                    </button>
                </div>
            )}
        </div>
    )
}